import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';

const Major = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanSmartMeterBackupSwitch');

    const list = [`major_text1`, `major_text2`, `major_text3`];
    return (
        <div className={styles.major}>
            <div className="content">
                <div className="text-container">
                    <h2>{t(`major_title`)}</h2>
                    <ul className="intro">
                        {list.map((item, index) => (
                            <li key={index}>
                                {t.rich(item, {
                                    sup: (text: string) => <sup>{text}</sup>,
                                })}
                            </li>
                        ))}
                    </ul>
                </div>
                <EFPicture
                    src={'https://websiteoss.ecoflow.com/upload/image/1750834306691/Major_pc.jpg'}
                    srcMobile={'https://websiteoss.ecoflow.com/upload/image/1750834322783/Major_h5.jpg'}
                    alt={t('system_title')}
                    className="banner"
                />
            </div>
        </div>
    );
};

export default Major;
